import { useEffect } from 'react';
import { RunnerBridge } from '../../../../helpers';
import SherloModule from '../../../../SherloModule';
import prepareSnapshots from './prepareSnapshots';
import { isStorybook7 } from '../../../helpers';
function useSetInitialTestingData({ view }) {
    const lastState = SherloModule.getLastState();
    useEffect(() => {
        if (lastState)
            return;
        (async () => {
            await waitForStorybookReady(view);
            const allStories = prepareSnapshots({ view, splitByMode: true });
            RunnerBridge.log('start testing session', {
                isStorybook7,
                storiesCount: allStories.length,
            });
            await RunnerBridge.send({
                action: 'START',
                snapshots: allStories,
            });
        })();
    }, []);
}
export default useSetInitialTestingData;
/* ========================================================================== */
async function waitForStorybookReady(view) {
    while (true) {
        const isReady = Object.keys(view._idToPrepared).length > 0;
        if (isReady) {
            return true;
        }
        await new Promise((resolve) => setTimeout(resolve, 500));
    }
}
//# sourceMappingURL=useSetInitialTestingData.js.map